export const aboutText = [
  `
שיטת מונטה קרלו משמשת לסימולציה של מערכות מורכבות בהנדסה, בכלכלה ובמדעים, ונעזרת ביכולתם של מחשבים ליצור מספרים אקראיים. נדגים שימוש שלה להמחשת  סכנת התפשטות מגפה. 
`,
  `
 .האפליקציה עושה סימולציה לאוכלוסיה. האנשים ("כדורים") נפגשים אלו עם אלו ואחד מהם ("כדור חום") חולה ומעביר מחלה. כשהוא פוגש אחרים הוא מדביק אותם, וההדבקה מתפשטת. מהירות ההדבקה תלויה בצפיפות האוכלוסייה ובתכיפות המפגשים.
 לאחר זמן מסוים, הנדבקים מחלימים (הופכים לכחולים). הסיכוי להדבק במפגש עם נשא הוא פרמטר
 `,
];
